import FormatCurrency from 'components/Common/FormatCurrency'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'
import type { ComponentProps } from 'react'
import { useIntl } from 'react-intl'

type InheritedFormatCurrencyProps = Pick<ComponentProps<typeof FormatCurrency>, 'signDisplay'>

interface Props extends InheritedFormatCurrencyProps {
  nonMemberPrice: number
  className?: string
  /**
   * @default start
   */
  horizontalAlign?: 'start' | 'center' | 'end'
}

function PriceStackLuxPlusNonMemberPrice(props: Props) {
  const {
    nonMemberPrice,
    signDisplay,
    className,
    horizontalAlign = 'start',
  } = props
  const intl = useIntl()

  return <Group
    direction="vertical"
    horizontalAlign={horizontalAlign}
    className={className}
  >
    <Caption variant="medium" colour="neutral-one">
      {intl.formatMessage({
        id: 'HkNspBrTnW7vl9uDlTL2',
        defaultMessage: 'Non-member',
        description: 'Price stack label for non-member price display in the LuxPlus membership section',
      })}
    </Caption>
    <Caption variant="medium" weight="bold" colour="neutral-two">
      <FormatCurrency signDisplay={signDisplay} value={nonMemberPrice} format="roundedDollar" />
    </Caption>
  </Group>
}

export default PriceStackLuxPlusNonMemberPrice
